<template>
  <div class="prose prose-gray prose-p:mt-1 prose-p:mb-1 prose-li:mt-1 prose-li:mb-1 max-w-none" v-html="compiledMarkdown" />
</template>

<script setup>
import { computed } from 'vue'
import MarkdownIt from 'markdown-it'

const props = defineProps({
  content: {
    type: String,
    required: true
  }
})

const md = new MarkdownIt({
  html: true,
  linkify: true,
  typographer: true,
  breaks: true
})

const compiledMarkdown = computed(() => md.render(props.content))
</script>
<style>
.text-white .prose * {
  color: white;
}
</style>
